import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {routes, routesLists} from "../../../../../core/models/static/routes/app-routes";
import {Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
import InventoryAdjustmentViews from "./inventory-adjustment";
import InventoryTransferViews from "./inventory-transfer";
import useAccessLevels from "../../../../hooks/use-access-levels";
import InventoryAvailabilityThresholds from "./availability-thresholds";


const InventoryViews = () => {
    const location = useLocation();
    const history = useHistory();
    const operatorAccessLevels = useAccessLevels();

    /**
     * Listens for the changes in the url and which each change
     * if the url is the same as /products, changes it immediately to the /products/list
     */
    useEffect(() => {
        if (!!matchPath(location.pathname, {path: routes.inventory.base, exact: true})) {
            if (
                operatorAccessLevels.packages.bizInventory.adjustmentReports ||
                operatorAccessLevels.packages.bizInventory.adjustmentList ||
                operatorAccessLevels.packages.bizInventory.adjustmentItems
            ) {
                history.replace(routes.inventory.inventoryAdjustment.base);
            } else if (operatorAccessLevels.packages.bizInventory.transferHistoryList) {
                history.replace(routes.inventory.inventoryTransfer.base);
            } else if (operatorAccessLevels.packages.bizInventory.viewAvailabilityThresholds) {
                history.replace(routes.inventory.availabilityThresholds);
            }
        }
    }, [history, location.pathname, operatorAccessLevels.packages.bizInventory.adjustmentItems, operatorAccessLevels.packages.bizInventory.adjustmentList, operatorAccessLevels.packages.bizInventory.adjustmentReports, operatorAccessLevels.packages.bizInventory.transferHistoryList, operatorAccessLevels.packages.bizInventory.viewAvailabilityThresholds])

    return (
        <Switch>
            <Route path={routes.inventory.base} exact/>
            <Route path={routesLists.inventoryAdjustment} exact>
                <InventoryAdjustmentViews/>
            </Route>
            <Route path={routesLists.inventoryTransfer} exact>
                <InventoryTransferViews/>
            </Route>
            {
                operatorAccessLevels.packages.bizInventory.viewAvailabilityThresholds &&
                <Route path={routes.inventory.availabilityThresholds} exact>
                    <InventoryAvailabilityThresholds/>
                </Route>
            }
            <Redirect to={routes.inventory.base.concat(routes.error.accessDeniedForSection)}/>
        </Switch>
    );
};

export default InventoryViews;
